// extracted by mini-css-extract-plugin
export default {"edit__btn":"EditButton_edit__btn__17P7y"};